import React, { useEffect, useState } from 'react';
import { StyleSheet, TouchableOpacity, View } from 'react-native';
import { Typography } from "../../../typography/Typography";
import { ColorTokens, FontFamilyTokens, FontSizeTokens, IconSizeTokens, IconTokens, SizeTypeTokens } from "@voltmoney/schema";
import { Icon } from "../../../icon/Icon";
import { Space } from "../../../space/Space";
import ThemeProvider from "@voltmoney/theme";
const SelectItemCard = ({ isSelected = true, title, subtitle, value, isDarkMode, onPress, isDisabled = false, onPressToolTip = () => { return; }, bgColor = undefined }) => {
    const [selected, setSelected] = useState(isDisabled ? false : isSelected);
    const [_isDisabled, setIsDisabled] = useState(isDisabled);
    const theme = ThemeProvider.getTheme();
    const colorMapping = theme.colors;
    useEffect(() => {
        setSelected(selected);
    }, [isSelected]);
    const handlePress = () => {
        !selected &&
            setSelected(true);
        onPress &&
            value &&
            onPress(value);
    };
    const handleOnPressToolTip = () => {
        onPressToolTip &&
            onPressToolTip();
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(TouchableOpacity, { style: [styles.container, {
                    borderWidth: 1,
                    borderColor: selected ? colorMapping[ColorTokens.Primary_100] : '#E4E7EC',
                    backgroundColor: bgColor ? bgColor : selected ? colorMapping[ColorTokens.Primary_05] : '#FFF',
                }], onPress: () => {
                !isDisabled && handlePress();
            } },
            React.createElement(View, { style: styles.selectItemLeftContainer },
                !_isDisabled &&
                    React.createElement(React.Fragment, null,
                        React.createElement(Icon, { name: selected ?
                                IconTokens.RadioCircleFilled
                                : IconTokens.RadioCircleNotFilled, size: IconSizeTokens.XXL }),
                        React.createElement(Space, { size: SizeTypeTokens.MD })),
                React.createElement(View, { style: styles.selectItemLeftContentContainer1 },
                    React.createElement(Typography, { label: title ? title : '', fontFamily: FontFamilyTokens.Inter, fontSize: FontSizeTokens.SM, fontWeight: '400', lineHeight: 20, color: (isDarkMode && selected) ? ColorTokens.DARK_GREY_THEME : ColorTokens.Grey_Charcoal }),
                    React.createElement(Typography, { label: subtitle ? subtitle : '', fontFamily: FontFamilyTokens.Inter, fontSize: FontSizeTokens.MD, fontWeight: '700', lineHeight: 24, color: (isDarkMode && selected) ? ColorTokens.White : ColorTokens.Grey_Night }))),
            React.createElement(TouchableOpacity, { style: styles.selectItemRightContainer, onPress: () => {
                    handleOnPressToolTip();
                } },
                React.createElement(Typography, { label: 'See how', fontFamily: FontFamilyTokens.Inter, fontSize: FontSizeTokens.XS, fontWeight: '400', lineHeight: 18, color: (isDarkMode && selected) ? ColorTokens.DARK_GREY_THEME : ColorTokens.Grey_Charcoal }),
                React.createElement(Space, { size: SizeTypeTokens.SM }),
                React.createElement(Icon, { name: IconTokens.Info, size: IconSizeTokens.MD, color: (isDarkMode && selected) ? ColorTokens.White : ColorTokens.Grey_Charcoal })))));
};
const styles = StyleSheet.create({
    container: {
        padding: 16,
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        borderRadius: 8,
    },
    content: {
        marginTop: 5,
    },
    toolTipContainer: {
        position: 'absolute',
        backgroundColor: '#FFF',
        color: 'white',
        padding: 16,
        borderRadius: 6,
        width: 250,
        bottom: '80%',
        left: '50%',
        transform: [{ translateX: -90 }],
        elevation: 5, // For Android shadow
    },
    selectItemLeftContainer: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'center',
        alignItems: 'center'
    },
    selectItemRightContainer: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'center'
    },
    selectItemLeftContentContainer1: {
        display: 'flex',
        flexDirection: 'column',
    }
});
export default SelectItemCard;
